import React from "react";
import CSVUploadForm from "./components/CSVUploadForm";

const CSVUploadFormContainer=()=><CSVUploadForm/>

export default CSVUploadFormContainer;